/* tslint:disable */
/* eslint-disable */
/**
 * K·HERO
 * K·HERO API documentation
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { EnStationComponentType } from './en-station-component-type';
 /**
 *
 *
 * @export
 * @interface CreateStationComponentDto
 */
export interface CreateStationComponentDto {

    /**
     * PSN or serial number
     *
     * @type {string}
     * @memberof CreateStationComponentDto
     */
    psn: string;

    /**
     * @type {EnStationComponentType}
     * @memberof CreateStationComponentDto
     */
    type: EnStationComponentType;

    /**
     * @type {string}
     * @memberof CreateStationComponentDto
     */
    manufacturer: string;

    /**
     * @type {string}
     * @memberof CreateStationComponentDto
     */
    supplier: string;

    /**
     * @type {string}
     * @memberof CreateStationComponentDto
     */
    purchased: string;

    /**
     * @type {number}
     * @memberof CreateStationComponentDto
     */
    warranty?: number;

    /**
     * @type {string}
     * @memberof CreateStationComponentDto
     */
    note?: string;
}
